export default __webpack_public_path__ + "static/media/mieux_gerer.a3266111.svg";